module.exports = __webpack_public_path__ + "img/DNARepair-NPC_GSE200310.91e7d483.png";